import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';

export default () => {
  return muster()
    .path('edelivery.getUserPreferences', {
      call: async ({ req }, { get, set }) => {
        const eDeliveryPreference = await getValues(get('roster.data.edelivery.getUserPreferences'));
        const edelPref = JSON.parse(eDeliveryPreference).edelPref;
        await set('edelivery.showPrompt', edelPref);
        if (edelPref === 0) {
          await set('edelivery.subscription', false);
        }
      },
    })

    .path('edelivery.updateUserPreference', {
      call: async ({ req }, { set }) => {
        await set('edelivery.subscription', true);
      },
    })

    .path('edelivery.saveUserPreferences', {
      call: async ({ req }, { get, set }) => {
        const preference = req.args[0];
        const screen = req.args[1];
        const [messages] = await getValues(get('i18n.messages'));
        const randomString = 'random' + Math.round(Math.random() * 100);

        // Call roster.data.cache to disable caching on the web
        const [eDeliveryPreference, _cache] = await getValues(get([`roster.data.edelivery.saveUserPreferences["${preference}"]["${screen}"]`, `roster.data.cache.${randomString}`]));

        const preferenceObject = JSON.parse(eDeliveryPreference);
        const edelPref = preferenceObject.edelPref;
        if (preferenceObject.statusCode === 500) {
          await set('callback.displayMsg', messages['app.rmcallback.errorMsg']);
          // alert(messages['app.rmcallback.errorMsg']);
          await set('edelivery.showPrompt', 2);
        } else if (edelPref !== null || edelPref !== undefined) {
          if (edelPref === 1) {
            await set('callback.displayMsg', messages['app.rmcallback.successMsg']);
            // alert(messages['app.edelivery.requestSubmittedDetailText']);
          } else {
            await set('edelivery.showPrompt', JSON.parse(eDeliveryPreference).edelPref);
          }
          await set('edelivery.showPrompt', JSON.parse(eDeliveryPreference).edelPref);
        }
      },
    })

    .path('edelivery.showPrompt', variable())
    .path('edelivery.subscription', variable(true));
};
